module.exports = __webpack_public_path__ + "static/w_hampton-32e2c99775fed62fa98498672bbb5278.png";